import React, { Component } from 'react';

import moment from "moment";
import _ from 'lodash';

import { getFormDataFromSku, sumScores, dementiaRiskCheck } from "./helper";
import DXFormSection from './DXFormSection';
import DXFormSectionTable from './DXFormSectionTable';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Button from 'components/CustomButtons/Button';

import styles from "./DXFormStyles"
import withStyles from "@material-ui/core/styles/withStyles";

import {
  Row,
  Col,
  Container
} from 'reactstrap';
import { Form04 } from 'views/Forms/CustomForms/Form04';


class DXFormViewer extends Component {
  constructor(props) {
    super(props);

    console.log('dxformviwers props = ', props);

    const { doc } = this.props;
    const { form } = doc;
    const { sku } = form;
    const data = getFormDataFromSku(sku);

    this.state = {
      doc,
      data,
      sku
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.doc.form.sku !== state.doc.form.sku) {
      const data = getFormDataFromSku(props.doc.form.sku);
      return {
        doc: props.doc,
        data
      }
    }
    return null;
  }

  change = () => {
    console.log("this.change call!");
  }

  renderSumForForm02_03 = () => {
    const { valueState: { 간이정신상태검사, 사전질문 } } = this.state.doc;
    const { gender, age } = this.state.doc.target;
    const educationYears = parseInt(사전질문?.사전질문?.교육수준);
    const score = sumScores(간이정신상태검사);

    const isRisky = dementiaRiskCheck(age, gender, educationYears, score) === true;
    const description = isRisky
      ? "치매가 의심되어 정밀진단검사를 받아야 합니다"
      : "정상군입니다";

    return <div className={`font-weight-bold text-center ${isRisky ? 'text-danger' : 'text-info'}`}>
      <h3>총점: {score} / 30점 ({description})</h3>
    </div>
  }


  renderSumForForm02_06 = () => {
    const { valueState: { 수단적일상생활활동 } } = this.state.doc;

    console.log('수단적일상생활활동', 수단적일상생활활동);

    const sum잠재능력 = _.sumBy(Object.values(수단적일상생활활동), '잠재능력') || 0;
    const sum현재실행 = _.sumBy(Object.values(수단적일상생활활동), '현재실행') || 0;

    // console.log('sum잠재능력', sum잠재능력);
    // console.log('sum현재실행', sum현재실행);

    return <div>
      <h4>현재실행: {sum현재실행} / 45점</h4>
      <h4>잠재능력: {sum잠재능력} / 45점</h4>
    </div>
  }

  renderSumForForm02_07 = () => {
    const { valueState: { 기본적일상생활활동 } } = this.state.doc;

    // console.log('기본적일상생활활동', 기본적일상생활활동);

    let sum = _.sum(Object.values(기본적일상생활활동).map(item => {
      const key = Object.keys(item).filter(key => !/.*State$/.test(key))[0]
      console.log('key', key);
      console.log('item[key]', item[`${key}`]);
      return item[key] || 0
    }));
    // console.log('sum', sum);

    return <div>
      <h4>총점: {sum} / 24점</h4>
    </div>
  }

  renderSumForForm02_10 = () => {
    const score = sumScores(this.state.doc.valueState["정서"]);

    return <div>
      <h4>총점: {score} / 15점 만점</h4>
    </div>
  }


  renderSumForForm02_13 = () => {
    const { valueState: { 정신행동증상 } } = this.state.doc;

    const sum증상유무 = _.sumBy(Object.values(정신행동증상), '증상유무') || 0;
    const sum심한정도 = _.sumBy(Object.values(정신행동증상), '심한정도') || 0;

    return <div>
      <h4>증상유무: {sum증상유무} / 12</h4>
      <h4>심한정도: {sum심한정도} / 36</h4>
    </div>
  }

  render() {
    if (this.state.sku === 'form04') {
      return <Form04
        {...this.props}
        readOnly
        org_id={this.props.org_id}
        currentDoc={this.state.doc}
      />
    } else {
      const { title, sections, targetGroup = null, description = null } = this.state.data;
      const { target, created_at, modified_at, reporter } = this.state.doc;

      return <Container>
        <Row>
          <Col>
            <Row id="printContent">
              <Col className='text-center'>
                <h2 style={{
                  paddingTop: '10px',
                  paddingBottom: '8px',
                }}>{title}</h2>
              </Col>
            </Row>
            <Row>
              <Col>
                <h4>등급자: {target.name}</h4>
                <h4>작성자: {reporter.displayName}</h4>
                <h4>작성일: {moment(created_at.toDate()).format('YYYY-MM-DD HH:mm:ss')}</h4>
                {
                  this.state?.doc?.form?.sku === 'form02_03'
                    ? this.renderSumForForm02_03()
                    : null
                }
                {
                  this.state?.doc?.form?.sku === 'form02_06'
                    ? this.renderSumForForm02_06()
                    : null
                }
                {
                  this.state?.doc?.form?.sku === 'form02_07'
                    ? this.renderSumForForm02_07()
                    : null
                }
                {
                  this.state?.doc?.form?.sku === 'form02_10'
                    ? this.renderSumForForm02_10()
                    : null
                }
                {
                  this.state?.doc?.form?.sku === 'form02_13'
                    ? this.renderSumForForm02_13()
                    : null
                }

                <h5><pre style={{
                  whiteSpace: 'pre-wrap',
                  wordWrap: "break-word"
                }}>{description}</pre></h5>
              </Col>
            </Row>
            <Row>
              <Col>
                {
                  sections.map(section => {
                    return section.type === "table"
                      ? <DXFormSectionTable
                        valueState={this.state.doc.valueState}
                        onChange={null}
                        setFormValueState={null}
                        section={section}
                        ref={r => this.tableSection = r}
                        showAlertAction={this.props.showAlertAction}
                        classes={this.props.classes}
                      />
                      : <DXFormSection
                        key={section.id}
                        // pid={section.id}
                        section={section}
                        form={this.state.doc.form}
                        valueState={this.state.doc.valueState}
                        onChange={null}
                        setFormValueState={null}
                        classes={this.props.classes}
                      />
                  })
                }
                {
                  this.state?.doc?.form?.sku === 'form02_03'
                    ? this.renderSumForForm02_03()
                    : null
                }
                {
                  this.state?.doc?.form?.sku === 'form02_06'
                    ? this.renderSumForForm02_06()
                    : null
                }
                {
                  this.state?.doc?.form?.sku === 'form02_07'
                    ? this.renderSumForForm02_07()
                    : null
                }
                {
                  this.state?.doc?.form?.sku === 'form02_13'
                    ? this.renderSumForForm02_13()
                    : null
                }
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    }

  }
}

export default withStyles(styles)(DXFormViewer);